import { useStatsigClient } from '@statsig/react-bindings'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { StasigLoadingState } from '@src/experiments/statsig-integration/statsig.types'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { getStorage } from '@src/utils/enhancedStorage'

import Cross from '../../icons/cross.inline.svg'
// eslint-disable-next-line import/no-named-as-default
import Link from '../link'

import styles from './cookieBanner.module.scss'

// @i18n-ignore
const LOCAL_STORAGE_COOKIE_CONSENT_KEY = 'cookieConsent'

const CookieBanner = () => {
  const [cookieConsent, setCookieConsent] = useState(true)
  const { t } = useTranslation('common')
  const { client } = useStatsigClient()

  useEffect(() => {
    setCookieConsent(getCookieConsentFromLocalStorage().cookieConsent)
  }, [])

  const handleCookieConsent = () => {
    setCookieConsent(true)
    updateCookieConsentInLocalStorage(true)
    trackEvent(TELEMETRY_EVENT_NAMES.BUTTON_CLICK, {
      // @i18n-ignore
      action: 'accept_cookies_consent',
    })
  }

  const trustArcCCMExperiment = client.getExperiment(STATSIG_EXPERIMENTS.TRUSTARC_CCM)
  const isTrustArcCCMEnable =
    trustArcCCMExperiment.groupName === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.TRUSTARC_CCM].buckets?.show

  if (isTrustArcCCMEnable)
    return (
      <>
        <div id="consent_blackbar"></div>
      </>
    )

  if (cookieConsent || client.loadingStatus !== StasigLoadingState.READY) return null

  return (
    <section className={styles.cookieBanner}>
      <div className={styles.cookieBanner__contentContainer}>
        <div className={styles.cookieBanner__contentContainer__text}>
          {t('we_use_first_and_third_party_cookies_and_similar_technologies_f')}{' '}
          <Link href="/terms" className={styles.cookieBanner__contentContainer__infoLink}>
            {t('terms_of_use')}
          </Link>{' '}
          {t('and')}{' '}
          <Link href="/privacy-policy" className={styles.cookieBanner__contentContainer__infoLink}>
            {t('privacy_notice')}
          </Link>
          {'.'}
        </div>
      </div>
      <div className={styles.cookieBanner__ctaContainer}>
        <Cross
          // @i18n-ignore
          role="button"
          className={styles.cookieBanner__ctaContainer__cta}
          onClick={handleCookieConsent}
        />
      </div>
    </section>
  )
}

interface ICookieConsent {
  cookieConsent: boolean
}

const getCookieConsentFromLocalStorage = (): ICookieConsent => {
  const cookieConsentString = getStorage().getItemJSON<ICookieConsent>(LOCAL_STORAGE_COOKIE_CONSENT_KEY, {
    isGlobal: true,
  })
  return cookieConsentString ? cookieConsentString : { cookieConsent: false }
}

const updateCookieConsentInLocalStorage = (accept: boolean) => {
  const cookieConsent: ICookieConsent = { cookieConsent: accept }
  getStorage().setItemJSON(LOCAL_STORAGE_COOKIE_CONSENT_KEY, cookieConsent, { isGlobal: true })
}

export default CookieBanner
